import { Dispatch, SetStateAction } from 'react';
import { Property } from 'types/onboarding';
import { CheckLarge } from '../check-large/CheckLarge';
import { Modal } from 'components/modal/Modal';
import { PackageList } from '../address/PackageList';
import { mapProductName } from '../address/Address';
import AccordionContainer from '../address/AccordionContainer';
import { useResize } from 'hooks/useResize';
import styles from './BoxForm.module.scss';
import { useSelectPackagesForOne } from 'hooks/onboarding/useSelectPackagesForOne';
import { PackageAccordion } from '../address/PackageAccordion';
import TransparentButton from 'components/new-buttons/TransparentButton';

interface SelectPackageForOneProps {
  setProperty: Dispatch<SetStateAction<Property | undefined>>;
  property: Property;
}

export const SelectPackageForOne = ({
  property,
  setProperty,
}: SelectPackageForOneProps) => {
  const { isTablet } = useResize();

  const {
    modalVisible,
    setModalVisible,
    activeProperty,
    setActiveProperty,
    selectProduct,
    findProduct,
  } = useSelectPackagesForOne({ setProperty, property });

  const showModalButton = (product?: string) => {
    return product ? mapProductName(product) : 'Velja orkuleið';
  };
  const label = `${property.address}, `.concat(
    property.fNumber
      ? `${property.postalCode} ${property.city}, ${property.fNumber}`
      : `${property.postalCode} ${property.city}`
  );

  const propertyId = property?.ean || property.fNumber;

  return (
    <div className={styles.selectPackage}>
      {isTablet ? (
        <>
          <p className={styles.address__mobileLabel}>{label}</p>

          <AccordionContainer title={showModalButton(property.product)}>
            <PackageAccordion
              onSelectPackage={(packageId) => {
                selectProduct(packageId);
              }}
              product={findProduct(propertyId)}
            />
          </AccordionContainer>
        </>
      ) : (
        <CheckLarge
          name="address"
          value="item.address"
          buttonText={showModalButton(property.product)}
          defaultChecked={property.selected}
          label={label}
          onButtonClick={() => {
            setActiveProperty(propertyId);
          }}
        />
      )}

      <Modal
        active={modalVisible && Boolean(activeProperty)}
        className={styles.selectPackage__modal}
        onClose={() => {
          setModalVisible(false);
          setActiveProperty(null);
        }}
      >
        <div>
          <PackageList
            onSelectPackage={(packageId) => {
              selectProduct(packageId);
            }}
            product={findProduct(activeProperty)}
          />

          <div className={styles.unselect_button}>
            <TransparentButton
              text="Velja orkuleið seinna"
              onClick={() => {
                if (findProduct(activeProperty)) {
                  selectProduct('');
                }
                setModalVisible(false);
                setActiveProperty(null);
              }}
            />
          </div>
        </div>
      </Modal>
    </div>
  );
};
